module.exports = __webpack_public_path__ + "static/img/1.0dd281ef.png";